import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageSwitcherComponent } from './language-switcher/language-switcher.component';



@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    LanguageSwitcherComponent
  ],

  exports: [
    CommonModule,
    LanguageSwitcherComponent
  ]
})
export class LanguageModule { }
